import type { ReceiptTemplate } from '../schema';

export const rossTemplate: ReceiptTemplate = {
  id: 'ross',
  name: 'Ross Receipt',
  brand: 'ROSS',
  description: 'Ross Dress for Less discount store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ross-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ross.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'DRESS FOR LESS',
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ross-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ross-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'WOMENS DRESS', quantity: '1', price: '24.99', sku: '' },
          { id: '2', name: 'MENS SHIRT', quantity: '2', price: '9.99', sku: '' },
          { id: '3', name: 'HOME DECOR', quantity: '1', price: '14.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ross-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '59.96', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '4.95', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '64.91', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ross-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ross-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'YES FOR LESS!\n\nReturns within 30 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

